<div class="row mb-3">
  <div class="col-lg col-lg-12">
    <table class="table table-heading-5 padding-td-15 table-borderless mb-0">
      <tbody>
      <tr>
        <td class="max-w-140">{{ data?.MainObject }}</td>
        <td>{{ data?.ServiceDescription }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="clearfix"></div>

<div class="row">
  <!-- URL BADGES -->
  @if (hasUrlBadges()) {
    <div class="col-lg col-lg-12">
      <table class="table padding-td-15 table-borderless mt-0 mb-0 w-100">
        <tbody>
          <tr>
            <td class="text-center width-25">
              <app-rca-tag
                [tagName]="data?.MainObject"
                [active]="data?.Dev_Active"
                [inactive]="data?.Dev_InActive"
                [inactiveCount]="data?.Dev_InActive_Count"
                [type]="'DEV'"></app-rca-tag>
            </td>
            <td class="text-center width-25">
              <app-rca-tag
                [tagName]="data?.MainObject"
                [active]="data?.Flt_Active"
                [inactive]="data?.Flt_InActive"
                [inactiveCount]="data?.Flt_InActive_Count"
                [type]="'RCA-F'"></app-rca-tag>
            </td>
            <td class="text-center width-25">
              <app-rca-tag
                [tagName]="data?.MainObject"
                [active]="data?.Dmd_Active"
                [inactive]="data?.Dmd_InActive"
                [inactiveCount]="data?.Dmd_InActive_Count"
                [type]="'RCA-D'"></app-rca-tag>
            </td>
            <td class="text-center width-25">
              <app-rca-tag
                [tagName]="data?.MainObject"
                [active]="data?.Ovr_Active"
                [inactive]="data?.Ovr_InActive"
                [inactiveCount]="data?.Ovr_InActive_Count"
                [type]="'RCA-O'"></app-rca-tag>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  }

  <!-- TYPE & MODEL -->

  <div class="col-lg col-lg-10">
    <table class="table padding-td-15 table-borderless mb-0">
      <tbody>
      <tr>
        <td class="max-w-140">Type:</td>
        <td>{{ data.Type }}</td>
      </tr>
      <tr>
        <td class="max-w-140">Manufacturer:</td>
        <td>{{ data.Manufacturer }}</td>
      </tr>
      <tr>
        <td class="max-w-140">Model:</td>
        <td>{{ data.Model }}</td>
      </tr>
      @if (data.DisplayRange) {
        <tr>
          <td class="max-w-140">Display Range:</td>
          <td>{{ data.DisplayRange }}</td>
        </tr>
      }
      <tr>
        <td colspan="2">&nbsp;</td>
      </tr>
<!--      <tr>-->
<!--        <td class="max-w-140">Func. Test progr.:</td>-->
<!--        <td>{{ data.FuncTestProgr }}</td>-->
<!--      </tr>-->
      </tbody>
    </table>
  </div>
  <div class="col-lg col-lg-2">
    @if (data.EqHubTekNo) {
      <a [href]="data.EqHubTekNo" class="mb-3 float-lg-end doc-db-icon" target="_blank">
        <img src="./assets/images/icons/doc-db_icon.svg" alt="">
      </a>
      <div class="clearfix"></div>
    }

    @if (data.MainObject_Sif) {
      <a
        [routerLink]="['/spas/sif-manual/overview']"
        [queryParams]="getSIFParams(data.MainObject)"
        title="SIF"
        class="mb-3 float-lg-end fs-14 lh-14 clickable pt-0 pb-0 px-1 pe-1 font-weight-bold d-block"
        target="_blank">
        SIF
      </a>
      <div class="clearfix"></div>
    }

    @if (displayNotificationIcon(data.Notifications_Status)) {
      <a [ngClass]="{
        'float-lg-end fs-18 pt-0 pb-0 px-1 pe-1 d-block': true,
        'clickable': data.Notifications_Status === 1,
        'clickable-light': data.Notifications_Status === -1
        }" (click)="onOpenNotificationModal(data.MainObject)" title="Notifications">
        <i class="fa fa-tools"></i>
      </a>
    }
  </div>

  <!-- AREA & COVERAGE -->

  <div class="col-lg col-lg-12 mb-3">
    <hr>
    <table class="table padding-td-15 table-borderless mb-0">
      <tbody>
        @if (data.FireArea) {
          <tr>
            <td class="max-w-140">Fire Area:</td>
            <td colspan="2">{{ data.FireArea }}</td>
          </tr>
        }
        @if (data.CoveragePercent) {
          <tr>
            <td class="max-w-140">Coverage %:</td>
            <td colspan="2">{{ data.CoveragePercent }}</td>
          </tr>
        }
        <tr>
          <td colspan="5">&nbsp;</td>
        </tr>
        @if (data.AHH_Value) {
          <tr>
            <td class="max-w-140 font-weight-bold">AHH:</td>
            <td class="font-weight-bold">{{ data.AHH_Value }}</td>
            <td>
              <app-rca-tag
                [tagName]="data?.AHH_MainObject"
                [active]="data?.AHH_Dmd_Active"
                [inactive]="data?.AHH_Dmd_InActive"
                [inactiveCount]="data?.AHH_Dmd_InActive_Count"
                [type]="'RCA-D'"></app-rca-tag>
            </td>
            <td>
              <app-rca-tag
                [tagName]="data?.AHH_MainObject"
                [active]="data?.AHH_Ovr_Active"
                [inactive]="data?.AHH_Ovr_InActive"
                [inactiveCount]="data?.AHH_Ovr_InActive_Count"
                [type]="'RCA-O'"></app-rca-tag>
            </td>
            <td>
              @if (data.AHH_Sif) {
                <a
                  [routerLink]="['/spas/sif-manual/overview']"
                  [queryParams]="getSIFParams(data.AHH_MainObject)"
                  title="SIF"
                  class="mt-1 float-lg-end fs-14 lh-14 clickable pt-0 pb-0 px-1 pe-1 font-weight-bold"
                  target="_blank">
                  SIF
                </a>
              }
            </td>
          </tr>
        }
        @if (data.AH_Value) {
          <tr>
            <td class="max-w-140 font-weight-bold">AH:</td>
            <td class="font-weight-bold">{{ data.AH_Value }}</td>
            <td>
              <app-rca-tag
                [tagName]="data?.AH_MainObject"
                [active]="data?.AH_Dmd_Active"
                [inactive]="data?.AH_Dmd_InActive"
                [inactiveCount]="data?.AH_Dmd_InActive_Count"
                [type]="'RCA-D'"></app-rca-tag>
            </td>
            <td>
              <app-rca-tag
                [tagName]="data?.AH_MainObject"
                [active]="data?.AH_Ovr_Active"
                [inactive]="data?.AH_Ovr_InActive"
                [inactiveCount]="data?.AH_Ovr_InActive_Count"
                [type]="'RCA-O'"></app-rca-tag>
            </td>
            <td>
              @if (data.AH_Sif) {
                <a
                  [routerLink]="['/spas/sif-manual/overview']"
                  [queryParams]="getSIFParams(data.AH_MainObject)"
                  title="SIF"
                  class="mt-1 float-lg-end fs-14 lh-14 clickable pt-0 pb-0 px-1 pe-1 font-weight-bold"
                  target="_blank">
                  SIF
                </a>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- CHARTS -->
<!--  <div class="col-lg col-lg-12">-->
<!--    <hr>-->
<!--    <app-chart-last-year-overview-->
<!--      [chartType]="'FAULT'"-->
<!--      [chartBarColor]="'#f59497'"-->
<!--      [chartData]=getChartData()></app-chart-last-year-overview>-->

<!--    <app-chart-last-year-overview-->
<!--      [chartType]="'BLOCKED'"-->
<!--      [chartBarColor]="'#68d6fc'"-->
<!--      [chartData]=getChartData()></app-chart-last-year-overview>-->
<!--  </div>-->

</div>
